import { render, staticRenderFns } from "./userAccount.vue?vue&type=template&id=2e4219e7"
import script from "./userAccount.vue?vue&type=script&lang=js"
export * from "./userAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports